import { render, staticRenderFns } from "./SubnetDetailModal.vue?vue&type=template&id=3b643bcc&scoped=true&"
import script from "./SubnetDetailModal.vue?vue&type=script&lang=ts&"
export * from "./SubnetDetailModal.vue?vue&type=script&lang=ts&"
import style0 from "./SubnetDetailModal.vue?vue&type=style&index=0&id=3b643bcc&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b643bcc",
  null
  
)

export default component.exports